import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/services';

import { NavigationService } from '../service/navigation.service';

@Component({
    selector: 'app-left-nav',
    templateUrl: './left-nav.component.html',
    styleUrls: ['./left-nav.component.scss'],
    standalone: false
})
export class LeftNavComponent implements OnInit {
  public user: any;
  public menuList: Array<any> = [
    {
      id: '8',
      route: '/app/dashboard',
      label: 'Dashboard',
      permissionKey: 'dashboardAccess',
    },
    {
      id: '1',
      route: '/app/projects',
      label: 'Projects',
      permissionKey: 'projectAccess',
    },
    {
      id: '2',
      route: '/app/employees',
      label: 'Employees',
      permissionKey: 'employeeAccess',
    },
    {
      id: '3',
      route: '/app/clients',
      label: 'Clients',
      permissionKey: 'clientAccess',
    },
    {
      id: '5',
      route: '/app/assets',
      label: 'Assets',
      permissionKey: 'assetAccess',
    },
    {
      id: '8',
      route: '/app/approvals',
      label: 'Approvals',
      permissionKey: 'approvalAccess',
    },
    {
      id: '9',
      route: '/app/campus',
      label: 'Campus',
      permissionKey: 'campusAccess',
    },
    {
      id: '10',
      route: '/app/vendor',
      label: 'Vendor',
      permissionKey: 'vendorAccess',
    },
    {
      id: '8',
      route: '/app/expense',
      label: 'Expense',
      permissionKey: 'expenseAccess',
    },
    {
      id: '11',
      route: '/app/helpdesk',
      label: 'Helpdesk',
      permissionKey: 'helpdeskSRMgmtAccess',
    },
    {
      id: '12',
      route: '/app/learn-development',
      label: 'L&D',
      permissionKey: 'learnDevelopmentAccess',
    },
    {
      id: '7',
      route: '/app/reports',
      label: 'Reports',
      permissionKey: 'reportAccess',
    },
  ];

  public selectedMenu: string = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    public navigationSevice: NavigationService
  ) {
    this.user = this.authService.userValue;
    this.router.events.subscribe((event) => {
      if (this.router.url.toString()) {
        this.selectedMenu = this.router.url.toString();
      }
    });
  }

  ngOnInit() {
    this.menuList = this.menuList.filter((module: any) => {
      const hasPermission = this.getPermissionToShow(module.permissionKey);
      return hasPermission;
    });
  }

  fnSelectMenu(menu: any) {
    this.selectedMenu = menu;
  }

  getIconPath(label: string, active: boolean) {
    return `./assets/menu-items/${label}${active ? '-Active' : ''}.svg`;
  }

  getPermissionToShow(key: string): boolean {
    const permission = this.user?.roleClass?.permissionRef?.[key];

    // For basic access keys (check for non-'NA' string)
    if (
      [
        'dashboardAccess',
        'approvalAccess',
        'campusAccess',
        'expenseAccess',
        'learnDevelopmentAccess'
      ].includes(key)
    ) {
      return permission !== 'NA';
    }

    // If it's a string, check for 'R'
    if (typeof permission === 'string') {
      return permission.includes('R');
    }

    // If it's an object, check if any value includes 'R'
    if (typeof permission === 'object' && permission !== null) {
      return Object.values(permission).some(
        (val) => typeof val === 'string' && val.includes('R')
      );
    }

    // Default: no access
    return false;
  }
}
